import { inject, injectable } from 'inversify';

import { ReactHookService } from '../../../shared/core/application/React.hook.service';
import {
  ManifestToastConfig,
  TApiDataState,
  TUseApiRequestWrapper,
} from '../../../shared/core/domain/interfaces';

@injectable()
export class ReactHookServicePort {
  constructor(
    @inject(ReactHookService)
    private readonly reactHookService: ReactHookService,
  ) {}

  public readonly composeUseApiRequestWrapper = (): TUseApiRequestWrapper => {
    return this.reactHookService.composeUseApiRequestWrapper();
  };

  public readonly composeApiRequestHook = <T, K>(
    promiseFn: (...args: Array<T>) => Promise<K>,
    options?: {
      manifestToast?: {
        error?: ManifestToastConfig;
        success?: ManifestToastConfig;
      };
    },
  ): [
    TApiDataState<K>,
    (...promiseArguments: Array<T>) => Promise<K | undefined>,
  ] => {
    const handleSuccess = options?.manifestToast?.success;

    const [state, functionCaller] =
      this.reactHookService.composeUseApiRequestWrapper()(promiseFn, {
        manifestToast: {
          handleSuccess: handleSuccess ? () => handleSuccess : undefined,
          handleError: (error) => {
            const supportReferenceId =
              error.response?.supportReferenceId || 'n/a';

            const errorMessage =
              error.response?.errorMessage || 'Unknown Error';

            return [
              errorMessage,
              {
                duration: 10000,
                isDismissable: true,
                description: `Reference ID: ${supportReferenceId}`,
              },
            ];
          },
        },
      });

    return [state, functionCaller];
  };
}
